import { render, staticRenderFns } from "./LogoList.vue?vue&type=template&id=d5770e0a&scoped=true&"
import script from "./LogoList.vue?vue&type=script&lang=js&"
export * from "./LogoList.vue?vue&type=script&lang=js&"
import style0 from "./LogoList.vue?vue&type=style&index=0&id=d5770e0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5770e0a",
  null
  
)

export default component.exports